import React from "react"
import { theme } from "../theme"
import { Container } from "react-grid-system"

const PageContainer: React.FunctionComponent<React.PropsWithChildren<{ wide?: boolean; fullHeight?: boolean }>> = ({
  children,
  wide,
  fullHeight,
}) => {
  return (
    <Container
      data-testid="page-container"
      style={{ maxWidth: wide ? "100%" : theme.containers.small, minHeight: fullHeight ? "100vh" : undefined }}
    >
      {children}
    </Container>
  )
}

export default PageContainer
